import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {renderIf} from "../../../Shared";
import {GoDotFill} from "react-icons/go";
import classNames from "classnames";
import {AttendanceActionTypes} from "../../../AppLocals/Course";
import dayjs from "dayjs";

export const renderCourseClassAttendance = ({renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {

    const {total_students, total_attendance, subject, number_of_sessions, attendance_date} = item ?? {}

    const dateObj = attendance_date ? dayjs(attendance_date) : null

    const percent_num = total_students > 0
        ? parseFloat(((total_attendance / total_students) * 100).toFixed(1))
        : 0
    const percent_session = total_students > 0
        ? percent_num.toFixed(1)
        : null

    let barColor = 'bg-color-100'
    let percentColor = 'text-color-300'
    let borderColor = 'border-color-100'
    if (percent_num >= 75) {
        barColor = 'bg-green-500'
        percentColor = 'text-green-500'
        borderColor = 'border-green-400'
    } else if (percent_num >= 50) {
        barColor = 'bg-blue-500'
        percentColor = 'text-blue-500'
        borderColor = 'border-blue-400'
    } else if (percent_num > 0) {
        barColor = 'bg-red-400'
        percentColor = 'text-red-500'
        borderColor = 'border-red-400'
    }

    return (
        <Translate key={index}>
            {(t) => (
                <div className={classNames(
                    "flex items-center gap-3 px-3 py-2.5 custom-item-render relative border-l-2",
                    total_students > 0 ? borderColor : 'border-transparent'
                )}>
                    {/* Date badge */}
                    {dateObj ? (
                        <div
                            className="flex flex-col items-center justify-center rounded-lg border border-color-100 px-2 py-1.5 flex-shrink-0 background-50"
                            style={{minWidth: 44}}>
                            <span className="text-sm font-bold text-color-100 leading-none">
                                {dateObj.format('DD')}
                            </span>
                            <span className="text-2xs text-color-400 leading-tight mt-0.5">
                                {dateObj.format('MM/YY')}
                            </span>
                        </div>
                    ) : (
                        <div
                            className="flex flex-col items-center justify-center rounded-lg border border-color-50 px-2 py-1.5 flex-shrink-0 background-50"
                            style={{minWidth: 44}}>
                            <span className="text-xs text-color-300">—</span>
                        </div>
                    )}

                    {/* Title + subject */}
                    <div
                        onClick={() => handleAction(AttendanceActionTypes.DETAIL, item)}
                        className="flex-1 min-w-0 cursor-pointer flex flex-col gap-0.5">
                        <span className="font-bold text-sm text-color-000 hover:text-primary truncate">
                            {getTitle(item)}
                        </span>
                        {subject && (
                            <div className="flex items-center gap-1 text-xs italic text-color-400">
                                <GoDotFill size={8} className="flex-shrink-0"/>
                                <span className="truncate">
                                    {`${getTitle(subject)} · ${number_of_sessions} ${t('sessions')}`}
                                </span>
                            </div>
                        )}
                    </div>

                    {/* Attendance stats */}
                    {total_students > 0 && (
                        <div className="flex flex-col items-end gap-1 flex-shrink-0">
                            <div className="flex items-center gap-2">
                                <div
                                    style={{width: 80}}
                                    className="h-1.5 rounded-full overflow-hidden bg-color-50">
                                    <div
                                        className={classNames("h-full rounded-full transition-all", barColor)}
                                        style={{width: `${Math.min(percent_num, 100)}%`}}
                                    />
                                </div>
                                <span className={classNames("font-bold text-xs w-12 text-right", percentColor)}>
                                    {percent_session}%
                                </span>
                            </div>
                            <span className="text-2xs text-color-400 italic">
                                {`${total_attendance}/${total_students} ${t('students')}`}
                            </span>
                        </div>
                    )}

                    {renderIf(
                        item?.course_class?.edit && renderContextMenu,
                        <div className="contextIcon flex-shrink-0">
                            {renderContextMenu(item)}
                        </div>
                    )}
                </div>
            )}
        </Translate>
    )
}
